module.exports = __webpack_public_path__ + "img/lalcec.a9732d71.png";